import { loadConfig } from 'settings'

const boostrapApp = async () => {
  await loadConfig()
  await import('./ReactApp')
}

boostrapApp()
